import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import * as L from 'leaflet';
import { DrawAreaSelection } from '@bopen/leaflet-area-selection';
import '@bopen/leaflet-area-selection/dist/index.css';

interface Props {
  onChange: (points: [number, number][]) => void;
}

const AreaSelectionControl: React.FC<Props> = ({ onChange }) => {
  const map = useMap();

  const onChangeRef = useRef(onChange);
  useEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);

  useEffect(() => {
    let lastPointsStr = '';

    const handlePolygonData = (polygon: L.Polygon) => {
      if (!polygon) return;

      const latLngs = polygon.getLatLngs();
      if (!latLngs || latLngs.length === 0) return;

      const points = Array.isArray(latLngs[0]) ? latLngs[0] : latLngs;

      const formattedPoints = (points as L.LatLng[]).map(p => [p.lat, p.lng] as [number, number]);

      const currentStr = JSON.stringify(formattedPoints);
      if (currentStr !== lastPointsStr) {
        lastPointsStr = currentStr;

        onChangeRef.current(formattedPoints);
      }
    };

    const areaSelection = new DrawAreaSelection({
      position: 'bottomright',

      onPolygonReady: (polygon: L.Polygon) => {
        handlePolygonData(polygon);
      },
    });

    map.addControl(areaSelection as unknown as L.Control);

    try {
      (areaSelection as any).activate();
    } catch (e) {
      console.warn('dont work plugin', e);
    }

    const pollInterval = setInterval(() => {
      const p = (areaSelection as any).polygon as L.Polygon;
      if (p) {
        handlePolygonData(p);
      }
    }, 500);

    return () => {
      clearInterval(pollInterval);
      try {
        (areaSelection as any).deactivate();
      } catch (e) {}
      map.removeControl(areaSelection as unknown as L.Control);
    };
  }, [map]);

  return null;
};

export default AreaSelectionControl;
